exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add[data-v-2b7659ca]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin-bottom:20px}.page[data-v-2b7659ca]{margin-top:20px}.avatar[data-v-2b7659ca]{width:120px;height:80px}.el-icon-plus[data-v-2b7659ca]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:1px dashed #dbdbdd}.img[data-v-2b7659ca]{height:60px}[data-v-2b7659ca] .el-dialog__body{height:60vh;overflow-y:scroll}\n", ""]);

// exports
